import React from 'react'
import { Input, Select, DatePicker, Tag, theme } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { getEventTypeTag } from '../utils/formatters'

const { Option } = Select
const { RangePicker } = DatePicker

const EventFilters = ({
  searchText,
  setSearchText,
  roomFilter,
  setRoomFilter,
  eventTypeFilter,
  setEventTypeFilter,
  statusFilter,
  setStatusFilter,
  dateRange,
  setDateRange,
  theatreRooms,
  eventTypes
}) => {
  const { token } = theme.useToken()

  return (
    <div style={{ marginBottom: '16px', display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'center' }}>
      <Input
        placeholder='Search events'
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        style={{ width: 250 }}
        prefix={<SearchOutlined />}
        allowClear
      />

      <Select
        placeholder='Theatre Room'
        style={{ width: 180 }}
        value={roomFilter}
        onChange={(value) => setRoomFilter(value)}
      >
        <Option value='all'>All Rooms</Option>
        {theatreRooms.map((room) => (
          <Option key={room} value={room}>
            {room}
          </Option>
        ))}
      </Select>

      <Select
        placeholder='Event Type'
        style={{ width: 180 }}
        value={eventTypeFilter}
        onChange={(value) => setEventTypeFilter(value)}
      >
        <Option value='all'>All Types</Option>
        {eventTypes.map((type) => (
          <Option key={type} value={type}>
            {getEventTypeTag(type)}
          </Option>
        ))}
      </Select>

      <Select
        placeholder='Status'
        style={{ width: 150 }}
        value={statusFilter}
        onChange={(value) => setStatusFilter(value)}
      >
        <Option value='all'>All Statuses</Option>
        <Option value='Completed'>Completed</Option>
        <Option value='In Progress'>In Progress</Option>
        <Option value='Delayed'>Delayed</Option>
        <Option value='Cancelled'>Cancelled</Option>
      </Select>

      <RangePicker onChange={(dates) => setDateRange(dates)} style={{ width: 280 }} />
    </div>
  )
}

export default EventFilters
